export const MAX_NAME_AMOUNT = 2
